import { useMemo } from 'react';
import { ColumnTable, Button, Icon } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { ReportAsyncTypeRow } from '../types';
import { TranslationsKeys } from '../../../../../locales/translations';
import dayjs from 'dayjs';

type UseReportsColumnsProps = {
  onPressGenerate?: (row: ReportAsyncTypeRow) => void;
};

export const useReportsColumns = (props: UseReportsColumnsProps) => {
  const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_REPORTS_ASYNC);

  const columns = useMemo<ColumnTable<ReportAsyncTypeRow>[]>(
    () => [
      {
        columnName: 'name',
        thClassName: 'text-left',
        tdClassName: 'text-left',
        headerText: t(`table.name`),
      },
      {
        columnName: 'description',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.description`),
      },
      {
        columnName: 'lastGenerated',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.lastGenerated`),
        cellFormat: ({ value }) =>
          value?.url ? (
            <a
              href={value.url}
              rel="noreferrer"
              target="_blank"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 5,
                textDecoration: 'none',
              }}
            >
              <strong className="text-dark">
                {dayjs(value.date).format('DD/MM/YY [-] HH:mm')}
              </strong>
              <Icon name="download" />
            </a>
          ) : (
            ''
          ),
      },
      {
        columnName: 'id',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`table.action`),
        cellFormat: ({ row }) => (
          <>
            <Button
              type="button"
              text={t(row.generating ? `table.generating` : `table.generate`)}
              disabled={row.generating}
              size="sm"
              onClick={() =>
                !!props?.onPressGenerate && props?.onPressGenerate(row)
              }
            />
          </>
        ),
      },
    ],
    [t, props],
  );

  return columns;
};
